export default {
  handleErrors (context, response) {
    if (response.status === 422) {
      context.state.errors = response.data.errors
    } else {
      context.state.errors = {}
    }
    context.commit('toggleLoading', false)
  },

  checkEmail (context, validEmail) {
    if (! validEmail) {
      context.state.errors.email = ['Invalid email address.'];
    }

    if (validEmail && context.state.errors.hasOwnProperty('email')) {
      delete context.state.errors.email
    }
  },

  checkNumber (context, validContactNumber) {
    if (! validContactNumber) {
      context.state.errors.contact_number = ['Invalid contact number. Contact number should start with (09) should be 11 digits'];
    }

    if (validContactNumber && context.state.errors.hasOwnProperty('contact_number')) {
      delete context.state.errors.contact_number
    }
  }
}
